import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Background,
  HeroSection,
  HeroStats,
  AuthSection,
  Card,
  Brand,
  Title,
  SubTitle,
  LoadingState,
  OAuthButton,
} from "./login.styles";
import { firebaseGoogleSignin } from "../../services/firebase/auth-with-provider";
import { useAuthenticate } from "../../services/api/users-api";
import { useQueryClient } from "@tanstack/react-query";

const LoginPage = () => {
  const userCount = 1200;
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  const { data: { data: userInfo } = {}, isLoading } = useAuthenticate({
    enabled: isAuthenticating,
  });

  const onGoogle = async () => {
    const { error } = await firebaseGoogleSignin();
    if (error) {
      alert(error);
      return;
    }
    setIsAuthenticating(true);
  };

  useEffect(() => {
    if (userInfo && !isLoading) {
      // Refresh the /me query so UserContext picks up the new user
      queryClient.invalidateQueries({ queryKey: ['users'] });

      const isProfileEmpty = userInfo?.profile?.is_profile_empty;

      if (!isProfileEmpty) {
        navigate("/default/profile");
      } else {
        navigate("/onboarding/choose-profile");
      }
    }
  }, [userInfo, isLoading, navigate, queryClient]);

  return (
    <Background>
      <HeroSection>
        <h1>Build your portfolio, not another form.</h1>
        <p>
          Portify helps you craft a profile that recruiters actually read. Keep your
          story, projects, and experience synced in one place.
        </p>
        <HeroStats>
          <span>{userCount}+ active users</span>
          {/* <span>Portfolio-first onboarding</span>
          <span>Share-ready profile links</span> */}
        </HeroStats>
      </HeroSection>

      <AuthSection>
        <Card>
          {isLoading ? (
            <LoadingState>
              <div className="loader" />
              <span>Signing you in...</span>
            </LoadingState>
          ) : (
            <>
              <Brand>
                <img src="/portify.jpg" alt="Portify logo" />
                <strong>Portify</strong>
              </Brand>

              <Title>Log in to continue</Title>
              <SubTitle>
                Continue with Google and jump back into your portfolio.
              </SubTitle>


              <OAuthButton onClick={onGoogle} disabled={isAuthenticating}>
                <img src="/google.png" alt="Google" />
                {isAuthenticating ? "Signing in..." : "Continue with Google"}
              </OAuthButton>
            </>
          )}
        </Card>
      </AuthSection>
    </Background>
  );
};

export default LoginPage;
